import React from "react";

interface DataTableFiltersActionProps {
  children: React.ReactNode;
}

/**
 * The listing's primary action. The root lifts it out of the wrapping control zone
 * into its own, so it holds the right of the FIRST row at every width; this renders
 * only the action itself.
 */
function FiltersAction({ children }: DataTableFiltersActionProps) {
  return <>{children}</>;
}

export { FiltersAction };
export type { DataTableFiltersActionProps };
